import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { MatDialog } from '@angular/material/dialog';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs';
import { InputAlertComponent } from '../../input-alert/input-alert.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { HighchartsService } from 'src/app/piechart/highcharts.service';
import { SurveillancesService } from '../surveillances.service';
import { DragDropTransferService } from '../../Gm-Dashboard/drag-drop-transfer.service';
import { AddemployeeComponent } from '../addemployee/addemployee.component';
import { HttpClient } from '@angular/common/http';
import { GridApi } from 'ag-grid-community';
import { LogTrackDialogComponent } from '../../Log-Tracking/log-track-dialog/log-track-dialog.component';
import { BuildinglistComponent } from '../buildinglist/buildinglist.component';

@Component({
  selector: 'app-surveillances',
  templateUrl: './surveillances.component.html',
  styleUrls: ['./surveillances.component.scss']
})
export class SurveillancesComponent {
  show: boolean = true
  search: boolean = true
  campusData: any;
  buildingData: any;
  dialogRef: any;
  employes: any;
  searchTerm: string = '';
  searchemployesslist: any;
  selectedImages: any = [];
  data1: any;
  empid: any;
  emp: any;
  imageUrls: string[] = [];
  imageUrl: string;
  employee: any;
  delected: any;
  subscription: any;
  cityControl: any = new FormControl();
  campusControl: any = new FormControl();
  filteredCampuses: any;
  filteredCity: any
  buildingId: any;
  empDetails: any;
  servicelist: any;
  payrollId: any;
  cityData: any;
  addcampus: any;
  selectedCampusId: any;
  employeeempId: any;
  emmloyeeampuslist: any;
  private gridApi!: GridApi;
  rowData: any[] = [];
  payload: { campusId: number; employeeId: number; };
  campusCount: any;
  filteredCampusCount: any;
  totalCampusCount: any;
  constructor(private dashboard: SurveillancesService, private dialog1: NgDialogAnimationService, private highcharts: HighchartsService, public http: HttpClient,
    private dailog: MatDialog, private toast: ToastmessageService, private dragDropService: DragDropTransferService, private cdr: ChangeDetectorRef, private spinner: NgxSpinnerService) {
    this.subscription = this.dragDropService.droppedItem$.subscribe((item: any) => {
      console.log('Received item from dialog:', item);
      if (!item.item.alreadyAdded) {
      }
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  columnDefs = [
    { headerName: 'State', field: 'stateName', },
    { headerName: 'City', field: 'cityName', },
    { headerName: 'Campus', field: 'campusName', flex: 1 },
    {
      headerName: 'Building Count',
      field: 'buildingCount',
      flex: 1,
      cellClass: ['ag-right-aligned-cell'],
      cellStyle: {
        cursor: 'pointer',
        color: '#007bff',
        textDecoration: 'underline'
      },
      onCellClicked: (params: any) => {
        this.openBuildingDialog(params.data);
      }
    },
    {
      headerName: 'Actions',
      width: 80,
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.style.background = 'transparent';
        button.style.border = 'none';
        button.style.cursor = 'pointer';
        button.style.padding = '0';
        button.style.display = 'flex';
        button.style.justifyContent = 'center';
        button.style.alignItems = 'center';
        button.style.width = '100%';
        button.style.height = '100%';
        button.innerHTML = `
      <i class="fas fa-trash" 
         style="
           font-size: 18px;
           color: red;
         ">
      </i>
    `;
        button.onclick = () => this.deleteSelectedRow(params.data);
        return button;
      }
    }
  ];

  defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1
  };

  autoGroupColumnDef = {
    headerName: 'Details',
    minWidth: 300,
    cellRendererParams: {
      suppressCount: false,
    },
  };

  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
  }
  ngOnInit(): void {
    this.AllServices();
    this.spinner.show()
  }
  allowDrop(event: DragEvent) {
    event.preventDefault();
  }
  private Filter(value: string, list: any[], name: string): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].trim().toLocaleLowerCase().includes(searchValue));
    return filteredList;
  }
  open() {
    this.dialogRef = this.dialog1.open(AddemployeeComponent, {
      width: "310px",
      height: "100%",
      position: { right: '0' },
      maxWidth: '100%',
      animation: { to: 'left' },
      autoFocus: false,
      disableClose: true,
      // hasBackdrop: false,
      data: this.searchemployesslist,
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value != true && value?.empId) {
        this.page(value)
      }
    })
  }

  opensearch() {
  }

  toggleSelection(image: any) {
    image.isSelected = !image.isSelected;
    this.selectedImages.push(image)
  }
  openCameraDialog(item: any) {
  }
  Dashboard() {
    this.spinner.show()
    this.show = true
    //  this.employee()
    this.employess()
    this.campusData = ''
    this.buildingData = ''
    this.spinner.hide()
  }
  employess() {
    this.spinner.show()
    this.dashboard.getemployeesdashboard().subscribe((res: any) => {
      this.employes = res
      this.employes = res;
      this.employes.forEach((emp: any) => {
        this.getImage(emp);
      });
      console.log("imeage", this.imageUrls);
      this.spinner.hide();
    })
  }
  getImage(emp: any) {
    this.spinner.show()
    const payrollId = emp.payrollId || emp.payRollId;
    this.dashboard.getimage(payrollId).subscribe({
      next: (blob: Blob) => {
        // this.spinner.show();
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          emp.imageUrl = reader.result as string;
          this.spinner.hide();

        };
      },
      error: (err: any) => {
        emp.imageUrl = 'assets/images/employee_notpresent.jpg';
        this.spinner.hide();
      }
    })

  }
  onCampusChange(event: any) {
    const selectedCampusId = event.cityId;
    if (selectedCampusId) {
      this.getcampus(selectedCampusId)
    }
    this.cityControl.setValue('');
  }
  onbuildingChange(event: any) {
    this.selectedCampusId = event.campusId;
    if (this.selectedCampusId) {
      this.getBuilding(this.selectedCampusId);
      this.campusControl.setValue('');
    }
  }
  onbuilding(event: any) {
    this.spinner.show()
    this.buildingId = event.buildingId;
  }
  onItemDropped(item: any) {
  }
  getcampus(selectedCampusId: any) {
    this.dashboard.campusdashboard(selectedCampusId).subscribe((res: any) => {
      this.campusData = res;
      this.filteredCampuses = this.campusControl.valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.campusData, 'campusName'))
      );
      console.log("list", this.campusData);
    });
  }
  getBuilding(selectedCampusId: any) {
    this.spinner.show()
    this.dashboard.getbuildingdashboard(selectedCampusId).subscribe((res: any) => {
      this.buildingData = res;
    })
    this.spinner.hide()
  }
  getcctv(buildingId: any) {
  }
  page(emp: any) {
    this.spinner.show()
    this.show = false
    this.employee = emp
    this.empDetails = emp
    console.log(this.employee)
    this.employee = emp.payRollId !== undefined ? emp.payRollId : emp.payrollId;
    this.dashboard.citydashboard().subscribe((res: any) => {
      this.spinner.show()
      this.cityData = res;
      this.filteredCity = this.cityControl.valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.cityData, 'cityName'))
      );
      console.log("list", this.cityData);
    })
    this.dashboard.getemployesssearch(this.employee).subscribe((res: any) => {
      this.searchemployesslist = res,
        this.searchemployesslist = Array.isArray(res) ? res : [res];
      this.empid = res.empId
      this.searchemployesslist.forEach((empy: any) => {
        this.getImage(empy);
        this.empid = this.searchemployesslist.empId
      });
    });
    this.allotampuslist()
    this.spinner.hide()
  }
  employessearch() {
    console.log("employess", this.searchTerm);
    this.dashboard.getemployesssearch(this.searchTerm).subscribe((res: any) => {
      this.searchemployesslist = res
      this.empid = this.searchemployesslist[0].empId
    })
    this.searchTerm = ''
  }
  Addcampus() {
    this.spinner.show()
    this.addcampus = this.empDetails
    this.employeeempId = this.addcampus.employeeId
    const payload = {
      employeeId: this.employeeempId,
      campusId: this.selectedCampusId
    };
    this.dashboard.addingcampus(payload).subscribe({
      next: (res) => {
        const response = res as any;
        const msg = response.message || "";

        if (msg.toLowerCase().includes("already")) {
          this.toast.showError(msg);
          this.spinner.hide()
        }
        else {
          this.toast.showSuccess(msg || "Campus added successfully!");
          this.spinner.hide()
          this.allotampuslist()
        }
      },
      error: (err) => {
        console.error("Error adding campus", err);
        this.toast.showError("adding campus deitals")
        this.spinner.hide()
      }
    });
  }
  deleteSelectedRow(row: any) {
    const selectedData = this.gridApi.getSelectedRows();
    if (selectedData.length === 0) {
      this.toast.showError("Please select a row to delete!");
      return;
    }
    if (selectedData.length > 1) {
      this.toast.showError("Please select only one campus!");
      return;
    }
    const selectedRow = selectedData[0];
    const selectedId = selectedRow.id;
    if (!confirm(`Do you want to delete the campus ${selectedRow.campusName}?`)) {
      return;
    }
    this.spinner.show()
    if (this.gridApi) {
      this.gridApi.applyTransaction({ remove: [row] });
    }
    this.payload = {
      "employeeId": selectedRow.employeeId,
      "campusId": selectedRow.campusId
    }

    this.dashboard.getdelectedcampus(this.payload).subscribe({
      next: (res) => {
        this.delected = res;
        this.toast.showSuccess('Campus deleted successfully!');
        this.allotampuslist()
      },
      error: (err) => {
        console.error(err);
        this.toast.showError('Error deleting campus!');
        this.spinner.hide()
      }
    });
    this.spinner.hide()
  }
  deleteRow(row: any) {
    if (!confirm(`Do you want to delete the campus ${row.campusName}?`)) {
      return;
    }
    this.spinner.show()
    if (this.gridApi) {
      this.gridApi.applyTransaction({ remove: [row] });
    }
    const payload = {
      employeeId: row.employeeId,
      campusId: row.campusId
    };
    this.dashboard.getdelectedcampus(payload).subscribe({
      next: (res) => {
        this.allotampuslist();
        this.spinner.hide()
        this.toast.showSuccess("Campus deleted successfully!");
      },
      error: () => {
        this.spinner.hide()
        this.toast.showError("Error deleting campus!");
      }
    });
  }
  onCameraDropToGM(event: DragEvent) {
  }
  AllServices() {
    if (this.highcharts.getRoles().length == 0) {
      this.spinner.show();
      this.highcharts.modulebaseurl().subscribe(
        {
          next: (res: any) => {
            this.servicelist = res;
            this.spinner.hide();
            console.log('service', this.servicelist);
            this.highcharts.setRoles(this.servicelist.moduleBaseURl);
            console.log('roleitem', this.highcharts.getRoles());
            this.employess()
          },
          error: (error: any) => {
            this.spinner.hide();
          }
        }
      )
    }
  }
  allotampuslist() {
    this.spinner.show()
    this.payrollId = this.employee;
    this.dashboard.employeeampuslist(this.payrollId).subscribe({
      next: (res: any) => {
        this.emmloyeeampuslist = res;
        this.rowData = res;
        this.totalCampusCount = res.length;
        this.filteredCampusCount = res.length;
        this.spinner.hide();
      },
      error: (err) => {
        console.error(err);
        this.spinner.hide();
        this.toast.showError("Failed to load campus list");
      }
    });
  }
  openBuildingDialog(row: any) {
    console.log("row", row);
    this.dialogRef = this.dialog1.open(BuildinglistComponent, {
      width: "400px",
      height: "100%",
      position: { right: '0' },
      maxWidth: '100%',
      animation: { to: 'left' },
      autoFocus: false,
      disableClose: true,
      data: row,
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value != true && value?.empId) {
        this.page(value)
      }
    })
  }
  onFilterChanged() {
    if (this.gridApi) {
      this.filteredCampusCount = this.gridApi.getDisplayedRowCount();
    }
  }
}

